import { render, staticRenderFns } from "./Inform.vue?vue&type=template&id=89a1c9b8&scoped=true&"
import script from "./Inform.vue?vue&type=script&lang=ts&"
export * from "./Inform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a1c9b8",
  null
  
)

export default component.exports